<template>
  <pt-lab-test-platform-new class="pt-lab-test-platform-new__withData"></pt-lab-test-platform-new>
</template>

<script>
import PtLabTestPlatformNew from './index'
export default {
  name: 'pt-lab-test-platform-new__withData',
  components: {
    'pt-lab-test-platform-new': PtLabTestPlatformNew
  }
}
</script>
